import { Provider } from '@angular/core';
import { TileViewService } from './tile-view.service';
import { MachineTaskService } from './machine-task.service';
import { ToolingTaskService } from './tooling-task.service';
import { DownloadService } from './download.service';
import { KpiService } from './kpi.service';
import { PictureService } from './picture.service';
import { TaskToastService } from './task-toast.service';
import { MachinesSearchService } from './machines-search.service';
import { ToolingSearchService } from './tooling-search.service';
import { StorageService } from '@schenck/rotec-components';

export const serviceProviders: Provider[] = [
  TileViewService,
  MachineTaskService,
  ToolingTaskService,
  DownloadService,
  KpiService,
  PictureService,
  TaskToastService,
  MachinesSearchService,
  ToolingSearchService,
  StorageService,
];

export * from './settings.service';
export * from './tile-view.service';
export * from './machine-task.service';
export * from './tooling-task.service';
export * from './download.service';
export * from './kpi.service';
export * from './picture.service';
export * from './task-toast.service';
export * from './machines-search.service';
export * from './tooling-search.service';
